var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 197,
    viewBox: "0 0 197 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_923_23231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.184 137.461H40.8184V180.015H156.184V137.461Z",
    fill: "url(#paint0_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.3756 72.4684L40.8184 103.967V83.4669C40.8074 71.0738 44.8075 59.01 52.2207 49.0786C52.7546 48.3556 53.3141 47.6464 53.8874 46.949C54.4606 46.2517 55.0832 45.5228 55.7076 44.8293C59.1148 41.0597 63.0012 37.7528 67.2676 34.9931C67.8179 34.6385 68.3734 34.2931 68.9342 33.9569C73.126 31.4409 77.6226 29.472 82.3145 28.0981C82.8661 27.9346 83.4255 27.7829 83.983 27.6371C88.3548 26.5019 92.8453 25.8876 97.3613 25.807C97.7376 25.7972 98.1198 25.7932 98.5 25.7932C98.6753 25.7932 98.8546 25.7932 99.0299 25.7932C103.541 25.831 108.032 26.3996 112.41 27.4874C112.97 27.6273 113.525 27.7711 114.077 27.9267C118.76 29.2402 123.257 31.1448 127.459 33.5944C128.02 33.9254 128.576 34.2603 129.126 34.605C133.913 37.6178 138.235 41.3138 141.954 45.576L118.594 59.0705L95.3756 72.4684Z",
    fill: "url(#paint1_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.379 48.5467L144.121 48.2098L144.174 48.2768C144.243 48.3674 144.312 48.462 144.379 48.5467Z",
    fill: "url(#paint2_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.184 83.4669V119.266H50.7118L121.516 78.3902L144.726 64.9942L151.621 61.0089C154.635 68.1121 156.185 75.7506 156.178 83.4669H156.184Z",
    fill: "url(#paint3_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8873 117.432V119.266H52.2207V118.395L53.8873 117.432Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2676 109.707L68.9342 108.746V119.266H67.2676V109.707Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3145 101.022L83.983 100.058V119.266H82.3145V101.022Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3613 92.3339L99.0299 91.3706V119.266H97.3613V92.3339Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.124 80.114V97.3278H127.457V79.7357L129.124 80.114Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.124 101.323H127.457V119.266H129.124V101.323Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.41 83.6462L114.077 82.6848V119.266H112.41V83.6462Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.174 83.5221V119.266H142.504V83.1438L144.174 83.5221Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8873 137.461H52.2207V180.015H53.8873V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9342 137.461H67.2676V180.015H68.9342V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.983 137.461H82.3145V180.015H83.983V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0299 137.461H97.3613V180.015H99.0299V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.077 137.461H112.41V180.015H114.077V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.124 137.461H127.457V180.015H129.124V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.174 137.461H142.504V180.015H144.174V137.461Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.982 83.4669V180.015H156.184V83.4669C156.184 51.6613 130.306 25.7853 98.5 25.7853C66.6944 25.7853 40.8204 51.6613 40.8204 83.4669V180.015H32.0184V83.4669C32.0184 46.752 61.7851 16.9853 98.5 16.9853C107.231 16.9851 115.876 18.7045 123.942 22.0454C132.008 25.3863 139.337 30.2833 145.51 36.4568C151.684 42.6302 156.581 49.9592 159.922 58.0252C163.262 66.0913 164.982 74.7364 164.982 83.4669Z",
    fill: "url(#paint4_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.594 59.0704L114.087 61.6728L112.42 62.6342L99.0398 70.3585L97.3614 71.314L95.3756 72.4605L83.9831 69.8798L82.3145 69.5036L68.9343 66.4737L67.2677 66.0955L53.8874 63.0656L52.2208 62.6874L45.3258 61.1251C47.1309 56.8443 49.4459 52.7969 52.2208 49.0707L52.2464 49.0372C52.4789 48.7233 52.7153 48.4134 52.9556 48.1074L53.1034 47.9104C53.9373 46.8479 54.8054 45.8163 55.7077 44.8155L67.2677 47.4336L68.9343 47.8119L82.3145 50.8417L83.9831 51.22L97.3614 54.2499L99.03 54.6281L112.41 57.6579L114.077 58.0362L118.594 59.0704Z",
    fill: "url(#paint5_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.184 83.4669V86.2407L144.167 83.5221L142.496 83.1438L129.116 80.114L127.459 79.7357L121.517 78.3902L127.459 74.9605L129.126 73.9971L142.506 66.2708L144.176 65.3075L144.728 64.9883L153.802 67.043C155.387 72.3734 156.189 77.9058 156.184 83.4669Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8873 63.0735V96.4217L52.2207 97.383V62.6953L53.8873 63.0735Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.983 27.6371V51.2338L82.3145 50.8556V28.0981C82.8661 27.9346 83.4255 27.777 83.983 27.6371Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.983 69.8877V79.0462L82.3145 80.0096V69.5114L83.983 69.8877Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0299 25.7893V54.6419L97.3613 54.2637V25.807C97.7376 25.7972 98.1197 25.7932 98.5 25.7932C98.6753 25.7853 98.8546 25.7853 99.0299 25.7893ZM129.124 34.605V52.993L127.459 53.9465V33.5944C128.018 33.9254 128.574 34.2603 129.124 34.605ZM114.077 27.9228V58.05L112.41 57.6717V27.4835C112.97 27.6233 113.525 27.777 114.077 27.9228ZM68.9342 33.9569V47.8257L67.2676 47.4475V34.9931C67.8179 34.6385 68.3734 34.2931 68.9342 33.9569Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9342 66.4816V87.734L67.2676 88.6973V66.1033L68.9342 66.4816Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.627 61.003L144.732 64.9883L144.18 65.3075L142.51 66.2708L129.13 73.9971L127.459 74.9605L121.517 78.3902L114.079 82.6848L112.412 83.6462L99.0319 91.3706L97.3633 92.3339L83.985 100.058L82.3164 101.022L68.9342 108.744L67.2676 109.705L53.8873 117.432L52.2207 118.397L50.7117 119.268L40.8184 124.981V103.967L52.2207 97.383L53.8873 96.4216L67.2676 88.6973L68.9342 87.7339L82.3144 80.0096L83.983 79.0462L95.3755 72.4684L97.3613 71.314L99.0299 70.3507L112.41 62.6263L114.077 61.6649L118.594 59.0704L127.459 53.9484L129.126 52.9871L141.954 45.5779L142.234 45.901L142.508 46.2241C142.793 46.559 143.077 46.8978 143.355 47.2426L143.552 47.4967C143.749 47.7351 143.932 47.9734 144.119 48.2138L144.172 48.2827L144.369 48.5506C144.632 48.8908 144.888 49.2342 145.138 49.5809L145.451 50.0144C145.695 50.3571 145.936 50.7019 146.174 51.0486C146.265 51.1826 146.355 51.3146 146.444 51.4426C146.586 51.6554 146.728 51.8701 146.867 52.0848C147.007 52.2996 147.118 52.4788 147.238 52.662C147.389 52.9004 147.539 53.1388 147.687 53.3791C147.783 53.5367 147.884 53.6943 147.973 53.8519C148.17 54.1789 148.363 54.5073 148.552 54.8369C148.642 54.9906 148.731 55.1482 148.82 55.3038C149.214 56.0038 149.592 56.713 149.954 57.4314C150.029 57.5752 150.102 57.719 150.173 57.8648C150.272 58.0618 150.37 58.2588 150.465 58.4558C150.583 58.7001 150.701 58.9463 150.815 59.1946C150.93 59.4428 151.062 59.7284 151.182 59.9963C151.235 60.1126 151.286 60.2308 151.337 60.347C151.442 60.5696 151.534 60.7863 151.627 61.003Z",
    fill: "url(#paint6_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.184 119.266H40.8184V137.461H156.184V119.266Z",
    fill: "url(#paint7_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6309 119.266L60.6759 122.209L48.3694 134.516L45.4262 137.461H40.8203V134.34C44.3663 130.794 47.9123 127.248 51.4583 123.702C52.9358 122.229 54.4127 120.752 55.8888 119.272L63.6309 119.266Z",
    fill: "url(#paint8_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3496 119.266L61.1567 137.461H53.4283L54.8861 136.003C58.9903 131.903 63.0925 127.8 67.1927 123.696C68.6702 122.223 70.1471 120.746 71.6233 119.266H79.3496Z",
    fill: "url(#paint9_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0801 119.266L92.1349 122.209L79.8303 134.516L76.8753 137.461H69.1588L70.6166 136.003C74.7182 131.903 78.8197 127.8 82.9212 123.696C84.4001 122.223 85.8776 120.746 87.3537 119.266H95.0801Z",
    fill: "url(#paint10_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.809 119.266L107.865 122.209L95.5588 134.516L92.6156 137.461H84.8893L86.3451 136.003C90.448 131.903 94.5502 127.8 98.6517 123.696C100.129 122.223 101.606 120.746 103.082 119.266H110.809Z",
    fill: "url(#paint11_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.539 119.266L108.35 137.461H100.618L102.076 136.003C106.18 131.903 110.282 127.8 114.382 123.696C115.86 122.223 117.337 120.746 118.813 119.266H126.539Z",
    fill: "url(#paint12_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.269 119.266L139.324 122.209L127.018 134.516L124.074 137.461H116.348L117.804 136.003C121.908 131.903 126.01 127.8 130.111 123.696C131.588 122.223 133.065 120.746 134.541 119.266H142.269Z",
    fill: "url(#paint13_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.184 119.266V121.08L155.055 122.209L142.748 134.516L139.805 137.461H132.079L133.534 136.003C137.637 131.903 141.739 127.8 145.841 123.696C147.319 122.223 148.795 120.746 150.272 119.266H156.184Z",
    fill: "url(#paint14_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0691 114.654C51.9522 114.719 51.8203 114.752 51.6866 114.75C51.5528 114.748 51.422 114.711 51.3073 114.642C51.1925 114.573 51.0978 114.476 51.0327 114.359C50.9676 114.242 50.9344 114.11 50.9364 113.976L51.1334 101.065C51.135 100.931 51.172 100.8 51.2405 100.685C51.309 100.57 51.4066 100.475 51.5236 100.41C51.6405 100.345 51.7726 100.312 51.9064 100.314C52.0402 100.316 52.1711 100.354 52.2858 100.423L63.3671 107.05C63.4824 107.118 63.5776 107.216 63.643 107.332C63.7085 107.449 63.742 107.581 63.74 107.715C63.738 107.849 63.7006 107.98 63.6317 108.095C63.5627 108.21 63.4646 108.305 63.3474 108.37L52.0691 114.654Z",
    fill: "url(#paint15_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.206 108.817C56.3028 108.757 56.4105 108.718 56.5228 108.7C56.6351 108.682 56.7497 108.687 56.8601 108.714C57.0674 108.776 57.2425 108.916 57.3478 109.105C57.4531 109.294 57.4803 109.516 57.4235 109.725C57.3509 109.943 57.1951 110.123 56.9901 110.225C56.8939 110.284 56.787 110.322 56.6756 110.339C56.5643 110.355 56.4508 110.348 56.342 110.32C56.2378 110.292 56.1408 110.243 56.0572 110.175C55.9737 110.107 55.9055 110.022 55.8573 109.926C55.8019 109.834 55.7664 109.731 55.7531 109.624C55.7399 109.517 55.7492 109.408 55.7805 109.305C55.852 109.093 56.0051 108.917 56.206 108.817ZM56.3538 107.779L55.2466 108.395L52.4886 103.825L53.911 103.037L56.3538 107.779Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0374 104.648C69.9204 104.713 69.7883 104.747 69.6544 104.744C69.5205 104.742 69.3895 104.705 69.2747 104.636C69.1599 104.567 69.0652 104.469 69.0002 104.352C68.9353 104.235 68.9023 104.103 68.9047 103.969L69.1017 91.0573C69.1039 90.9237 69.1412 90.793 69.2099 90.6784C69.2785 90.5638 69.3761 90.4692 69.4928 90.4041C69.6096 90.3391 69.7413 90.3059 69.8749 90.3078C70.0085 90.3097 70.1393 90.3467 70.2541 90.4151L81.3373 97.0442C81.4521 97.1128 81.5468 97.2105 81.6119 97.3273C81.677 97.4441 81.7102 97.5761 81.7082 97.7098C81.7063 97.8435 81.6691 97.9744 81.6005 98.0892C81.532 98.2041 81.4344 98.2988 81.3176 98.3641L70.0374 104.648Z",
    fill: "url(#paint16_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1744 98.8113C74.2707 98.7514 74.378 98.7113 74.49 98.6934C74.6019 98.6755 74.7163 98.68 74.8265 98.7068C74.9309 98.7348 75.0284 98.7843 75.1125 98.8521C75.1966 98.92 75.2656 99.0047 75.3151 99.1008C75.3703 99.1929 75.4055 99.2956 75.4184 99.4022C75.4313 99.5087 75.4216 99.6168 75.3899 99.7194C75.3106 99.9314 75.1584 100.108 74.9606 100.218C74.7628 100.328 74.5323 100.365 74.3104 100.32C74.1032 100.259 73.9283 100.119 73.8233 99.9308C73.7183 99.7422 73.6916 99.5198 73.7489 99.3116C73.782 99.2036 73.8369 99.1036 73.91 99.0175C73.9832 98.9315 74.0732 98.8613 74.1744 98.8113ZM74.3222 97.7731L73.2131 98.3897L70.4551 93.8193L71.8774 93.0313L74.3222 97.7731Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0038 94.6408C87.8875 94.7041 87.7568 94.736 87.6244 94.7334C87.4921 94.7308 87.3627 94.6938 87.249 94.626C87.1352 94.5582 87.0411 94.462 86.9759 94.3468C86.9107 94.2316 86.8766 94.1014 86.877 93.969L87.074 81.0576C87.0756 80.9238 87.1125 80.7927 87.1811 80.6777C87.2496 80.5627 87.3472 80.4679 87.4642 80.4027C87.5811 80.3375 87.7132 80.3044 87.847 80.3066C87.9808 80.3089 88.1117 80.3464 88.2264 80.4154L99.3096 87.0444C99.4243 87.1133 99.5189 87.2111 99.5838 87.328C99.6487 87.445 99.6818 87.5769 99.6796 87.7106C99.6774 87.8444 99.64 87.9752 99.5713 88.0899C99.5026 88.2047 99.4048 88.2993 99.288 88.3643L88.0038 94.6408Z",
    fill: "url(#paint17_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1409 88.8056C92.2373 88.7453 92.3449 88.705 92.4573 88.687C92.5696 88.6691 92.6844 88.6739 92.7949 88.7012C93.002 88.7631 93.1767 88.9033 93.2819 89.092C93.3872 89.2808 93.4146 89.5032 93.3583 89.7118C93.278 89.9236 93.1254 90.1002 92.9275 90.2105C92.7296 90.3208 92.4992 90.3577 92.2768 90.3147C92.0704 90.252 91.8964 90.1115 91.7916 89.9229C91.6869 89.7343 91.6595 89.5124 91.7153 89.304C91.7495 89.1968 91.8047 89.0975 91.8778 89.0119C91.9509 88.9263 92.0403 88.8562 92.1409 88.8056ZM92.2886 87.7674L91.1815 88.384L88.4235 83.8117L89.8458 83.0237L92.2886 87.7674Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.972 84.6351C105.855 84.7001 105.723 84.7332 105.59 84.7311C105.456 84.729 105.325 84.6917 105.21 84.623C105.096 84.5544 105.001 84.4567 104.936 84.3399C104.871 84.2231 104.837 84.0912 104.839 83.9575L105.036 71.0461C105.038 70.9122 105.076 70.7812 105.145 70.6662C105.213 70.5513 105.311 70.4565 105.428 70.3914C105.545 70.3263 105.677 70.2932 105.811 70.2954C105.945 70.2976 106.076 70.335 106.191 70.4039L117.274 77.027C117.389 77.0957 117.484 77.1933 117.549 77.3101C117.614 77.427 117.647 77.5589 117.645 77.6926C117.643 77.8264 117.606 77.9572 117.537 78.0721C117.469 78.1869 117.371 78.2817 117.254 78.3469L105.972 84.6351Z",
    fill: "url(#paint18_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.109 78.8C110.206 78.7404 110.314 78.7007 110.426 78.6831C110.538 78.6655 110.653 78.6704 110.763 78.6976C110.97 78.7598 111.144 78.9002 111.249 79.0889C111.354 79.2776 111.381 79.4998 111.325 79.7082C111.29 79.8161 111.234 79.916 111.16 80.0019C111.085 80.0879 110.995 80.1581 110.893 80.2085C110.798 80.2679 110.691 80.3075 110.579 80.3247C110.468 80.342 110.354 80.3366 110.245 80.309C110.141 80.2812 110.044 80.2317 109.96 80.1638C109.876 80.0959 109.807 80.0112 109.759 79.915C109.704 79.8224 109.669 79.7194 109.656 79.6126C109.643 79.5058 109.653 79.3974 109.684 79.2945C109.718 79.188 109.774 79.0895 109.847 79.0046C109.92 78.9198 110.009 78.8502 110.109 78.8ZM110.257 77.7618L109.15 78.3804L106.392 73.808L107.814 73.02L110.257 77.7618Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.941 74.6295C123.824 74.6946 123.691 74.7277 123.558 74.7255C123.424 74.7233 123.293 74.6858 123.178 74.6169C123.063 74.548 122.968 74.4501 122.903 74.333C122.838 74.2159 122.806 74.0838 122.808 73.9499L123.005 61.0405C123.007 60.9067 123.044 60.7758 123.112 60.6608C123.181 60.5459 123.278 60.4511 123.395 60.3858C123.512 60.3205 123.644 60.2871 123.778 60.289C123.911 60.2908 124.042 60.3278 124.157 60.3963L135.241 67.0253C135.355 67.094 135.45 67.1916 135.515 67.3085C135.58 67.4253 135.613 67.5572 135.611 67.6909C135.609 67.8247 135.572 67.9555 135.504 68.0704C135.435 68.1852 135.338 68.28 135.221 68.3452L123.941 74.6295Z",
    fill: "url(#paint19_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.078 68.7924C128.174 68.7325 128.281 68.6925 128.393 68.6745C128.505 68.6566 128.619 68.6612 128.73 68.688C128.937 68.7503 129.112 68.8909 129.217 69.0799C129.322 69.269 129.349 69.4917 129.293 69.7006C129.214 69.9126 129.061 70.0894 128.864 70.1995C128.666 70.3096 128.435 70.3457 128.213 70.3014C128.109 70.2739 128.012 70.2246 127.928 70.1567C127.844 70.0888 127.775 70.0038 127.727 69.9074C127.672 69.8147 127.637 69.7118 127.624 69.6051C127.611 69.4984 127.62 69.3901 127.65 69.2869C127.685 69.1802 127.741 69.0815 127.814 68.9966C127.887 68.9117 127.977 68.8423 128.078 68.7924ZM128.225 67.7542L127.116 68.3708L124.358 63.8004L125.779 63.0124L128.225 67.7542ZM129.124 83.5497C128.878 83.5379 128.63 83.5319 128.379 83.5319C128.07 83.5319 127.762 83.5418 127.457 83.5595C123.437 83.7974 119.659 85.5621 116.897 88.4926C114.135 91.4232 112.596 95.2982 112.596 99.3254C112.596 103.353 114.135 107.228 116.897 110.158C119.659 113.089 123.437 114.853 127.457 115.091C127.762 115.109 128.07 115.119 128.379 115.119C128.63 115.119 128.878 115.113 129.124 115.101C133.178 114.909 137.003 113.163 139.805 110.225C142.606 107.288 144.169 103.385 144.169 99.3254C144.169 95.2663 142.606 91.3629 139.805 88.4255C137.003 85.488 133.178 83.742 129.124 83.5497ZM139.381 100.027C139.381 100.37 139.244 100.7 139.001 100.943C138.758 101.186 138.429 101.322 138.085 101.323H118.673C118.329 101.322 118 101.186 117.757 100.943C117.514 100.7 117.377 100.37 117.376 100.027V98.6241C117.376 98.2803 117.513 97.9506 117.756 97.7075C117.999 97.4644 118.329 97.3279 118.673 97.3279H138.085C138.429 97.3279 138.759 97.4644 139.002 97.7075C139.245 97.9506 139.381 98.2803 139.381 98.6241V100.027Z",
    fill: "#C799FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.921 80.7109C164.958 81.625 164.982 82.543 164.982 83.4689V116.409H179.152C179.252 116.409 179.349 116.409 179.457 116.409C184.191 116.369 188.715 114.449 192.034 111.073C195.352 107.697 197.194 103.141 197.154 98.4074C197.113 93.6735 195.194 89.1496 191.818 85.8308C188.442 82.5121 183.886 80.6704 179.152 80.7109H164.921Z",
    fill: "url(#paint20_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2922 45.0125H44.2639C56.3104 28.0528 76.1129 16.9853 98.5 16.9853C109.614 16.9882 120.551 19.7756 130.311 25.0931C140.07 30.4105 148.342 38.0885 154.371 47.4258C157.093 45.8403 160.187 45.0074 163.337 45.0125H163.707C168.408 44.9631 172.9 43.0609 176.208 39.7188C179.515 36.3768 181.37 31.865 181.37 27.1633C181.37 22.4617 179.515 17.9498 176.208 14.6078C172.9 11.2658 168.408 9.36355 163.707 9.31416H32.2922C29.9324 9.28937 27.5912 9.73274 25.4039 10.6186C23.2166 11.5045 21.2266 12.8153 19.5492 14.4752C17.8717 16.1352 16.5401 18.1112 15.6313 20.2891C14.7225 22.467 14.2545 24.8034 14.2545 27.1633C14.2545 29.5232 14.7225 31.8597 15.6313 34.0376C16.5401 36.2155 17.8717 38.1915 19.5492 39.8514C21.2266 41.5114 23.2166 42.8222 25.4039 43.7081C27.5912 44.5939 29.9324 45.0373 32.2922 45.0125Z",
    fill: "url(#paint21_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5429 116.405C17.6453 116.405 17.7398 116.405 17.8482 116.405H30.4207C30.9605 116.405 31.4924 116.451 32.0184 116.506V83.4669C32.0184 82.543 32.042 81.625 32.0795 80.7089H17.8482C13.1334 80.6974 8.60561 82.5518 5.25346 85.8672C1.90131 89.1827 -0.00283797 93.6898 -0.0431693 98.4044C-0.0835007 103.119 1.74326 107.658 5.0382 111.03C8.33314 114.403 12.8286 116.334 17.5429 116.403V116.405Z",
    fill: "url(#paint22_linear_923_23231)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.183 152.104C180.509 152.025 179.831 151.986 179.152 151.987H164.982V180.015H32.0184V151.987H17.8482C17.1695 151.986 16.4913 152.025 15.8172 152.104C11.2862 152.619 7.12435 154.849 4.18566 158.336C1.24696 161.823 -0.245615 166.302 0.0142583 170.855C0.274132 175.407 2.26674 179.688 5.58313 182.818C8.89952 185.948 13.2881 187.69 17.8482 187.686H179.152C183.712 187.69 188.101 185.948 191.417 182.818C194.733 179.688 196.726 175.407 196.986 170.855C197.246 166.302 195.753 161.823 192.814 158.336C189.876 154.849 185.714 152.619 181.183 152.104Z",
    fill: "url(#paint23_linear_923_23231)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_923_23231",
    x1: 98.5019,
    y1: 93.7011,
    x2: 98.5019,
    y2: 210.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_923_23231",
    x1: 91.3863,
    y1: 82.5863,
    x2: 91.3863,
    y2: 180.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_923_23231",
    x1: 144.251,
    y1: 48.4541,
    x2: 144.251,
    y2: 48.8777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_923_23231",
    x1: 103.449,
    y1: 103.332,
    x2: 103.449,
    y2: 176.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_923_23231",
    x1: 98.5,
    y1: 55.6761,
    x2: 98.5,
    y2: 186.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_923_23231",
    x1: 71.1367,
    y1: 36.8981,
    x2: 106.445,
    y2: 112.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_923_23231",
    x1: 87.0799,
    y1: 50.0577,
    x2: 105.59,
    y2: 136.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_923_23231",
    x1: 98.5019,
    y1: 117.14,
    x2: 98.5019,
    y2: 155.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_923_23231",
    x1: 52.2207,
    y1: 116.334,
    x2: 52.2207,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_923_23231",
    x1: 66.389,
    y1: 116.334,
    x2: 66.389,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_923_23231",
    x1: 82.1194,
    y1: 116.334,
    x2: 82.1194,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_923_23231",
    x1: 97.8499,
    y1: 116.334,
    x2: 97.8499,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_923_23231",
    x1: 113.578,
    y1: 116.334,
    x2: 113.578,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_923_23231",
    x1: 129.309,
    y1: 116.334,
    x2: 129.309,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_923_23231",
    x1: 144.131,
    y1: 116.334,
    x2: 144.131,
    y2: 158.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_923_23231",
    x1: 49.711,
    y1: 95.7302,
    x2: 66.0069,
    y2: 128.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_923_23231",
    x1: 68.0556,
    y1: 86.4731,
    x2: 84.3534,
    y2: 118.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_923_23231",
    x1: 86.4002,
    y1: 77.2141,
    x2: 102.698,
    y2: 109.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_923_23231",
    x1: 104.747,
    y1: 67.9571,
    x2: 121.043,
    y2: 100.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_923_23231",
    x1: 123.092,
    y1: 58.6981,
    x2: 139.387,
    y2: 90.9884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#C799FF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_923_23231",
    x1: 180.96,
    y1: 75.8962,
    x2: 180.96,
    y2: 190.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_923_23231",
    x1: 97.9996,
    y1: 75.8962,
    x2: 97.9996,
    y2: 190.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_923_23231",
    x1: 16.0397,
    y1: 75.8962,
    x2: 16.0397,
    y2: 190.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_923_23231",
    x1: 98.5,
    y1: 75.8962,
    x2: 98.5,
    y2: 190.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C799FF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C799FF",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_923_23231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 197,
    height: 197,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessDenied);
export default __webpack_public_path__ + "static/media/access-denied.79e9f6ed0c09e47cab64f59998777ba0.svg";
export { ForwardRef as ReactComponent };